import { render } from "./Section-1.vue?vue&type=template&id=60a526f4&scoped=true"
import script from "./Section-1.vue?vue&type=script&lang=js"
export * from "./Section-1.vue?vue&type=script&lang=js"

import "./Section-1.vue?vue&type=style&index=0&id=60a526f4&scoped=true&lang=css"

import exportComponent from "C:\\Spinnov\\ace-challenge-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a526f4"]])

export default __exports__